import React, { useEffect, useState } from 'react';
import { Row, Col } from "react-bootstrap";
import CustomModal from "../../components/Modal/CustomModal";
import { ExportPdf, PrinterPdf, DownloadPdf } from '../../funciones/NotasCertificadasFunction';
import { UrlImg } from '../../shared/Url';

import CKEditor from 'ckeditor4-react';

CKEditor.editorUrl = 'ckeditor/ckeditor.js';

const ReportEdit = (props) => {
    const [dataHtml, setDataHtml]       = useState("")
    const [btnExport, setBtnExport]     = useState({icon: "fa fa-file-pdf-o", disabled: false})
    const [btnDownload, setBtnDownload] = useState({icon: "fa fa-download", disabled: false})
    const [btnPrint, setBtnPrint]       = useState({icon: "fa fa-print", disabled: false})
    const [modal, setModal]             = useState(false)
    const [src, setSrc]                 = useState("")
    const [numPags, setNumPags]         = useState("")
    const [heightD, setHeightD]         = useState(850)
    const [control, setControl]         = useState(false)

    useEffect(() => {
        let datHtml = props.dataHtml;
        let newData = datHtml.replace('PROMGRAL', props.prom)
        let cuenta = 0;
        let posicion = newData.indexOf("page-break-after:always");
        
        while ( posicion != -1 ) {
            cuenta++;
            posicion = newData.indexOf("page-break-after:always", posicion + 1);
        }
        
        let newPags = `Este documento consta de ${cuenta + 1}`
        newData = newData.replace('Este documento consta de NUMPAG', newPags)

        setNumPags(newPags)
        setDataHtml(newData)
        setHeightD(heightD + (850 * cuenta) + 425);
    }, [props]);

    /* useEffect(() => {
        let cintillo = `<p style="text-align:center"><img alt="logo" src="${UrlImg}logo_menu_black.png" style="height:100px" /></p>`;
        let membrete = `<p style="text-align:center"><span style="font-size:16px"><strong><span style="color:#000000">INSTITUTO UNIVERSITARIO DE DISE&Ntilde;O LAS MERCEDES</span></strong></span></p>

<p style="text-align:center"><span style="color:#000000"><span style="font-size:14px">M.E. N&ordm; 130 G.O. N&ordm; 36.719 9 JUNIO 1.999</span></span></p>`
        let encabezado = `<p style="text-align:center">&nbsp;</p>

<div style="page-break-after:always"><span style="display:none">&nbsp;</span></div>

<p style="text-align:center">&nbsp;</p>

${cintillo}

${membrete}

<p style="text-align:center">&nbsp;</p>`
        let busq = dataHtml.indexOf(encabezado);
        let newData2 = dataHtml.replace(new RegExp(encabezado,"g"), `<div style="page-break-after:always"><span style="display:none">&nbsp;</span></div>`);
        newData2 = newData2.replace(new RegExp(`<div style="page-break-after:always"><span style="display:none">&nbsp;</span></div>`,"g"), encabezado);
        
        let posicion = newData2.indexOf("page-break-after:always");
        let cuenta = 0;

        while ( posicion != -1 ) {
            posicion = newData2.indexOf("page-break-after:always", posicion + 1);
        }

        let newPags = `Este documento consta de ${cuenta + 1}`
        newData2 = newData2.replace('Este documento consta de NUMPAG', newPags)

        if (busq !== -1) setDataHtml(newData2);
    }, [numPags]); */

    let exportar = () => {
        if (btnExport.disabled === true) return null
        setBtnExport({icon: "fa fa-spinner fa-spin", disabled: true})
        ExportPdf (dataHtml, (resp) => {
            setSrc(resp)
            setModal(true)
            setBtnExport({icon: "fa fa-file-pdf-o", disabled: false})
        })
    }

    let imprimir = () => {
        if (btnPrint.disabled === true) return null

        setBtnPrint({icon: "fa fa-spinner fa-spin", disabled: true})

        PrinterPdf(dataHtml, () => {
            setBtnPrint({icon: "fa fa-print", disabled: false})
        })
    }

    let descargar = (nombre) => {
        if (btnDownload.disabled === true) return null

        setBtnDownload({icon: "fa fa-spinner fa-spin", disabled: true})
        DownloadPdf(dataHtml, nombre, () => {
            setBtnDownload({icon: "fa fa-download", disabled: false})
        })
    }

    const configuraciones = {
        toolbar: [
            [ 'Styles', 'Font', 'FontSize', 'lineheight', '-', 'Bold', 'Italic', 'Underline', '-', 'TextColor', 'BGColor', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-',
              'NumberedList', 'BulletedList', 'Table', 'Image', 'PageBreak', '-', 'Undo', 'Redo'/* , 'Source' */
            ],
        ],
        height: `${heightD}px`,
        removePlugins: 'resize, elementspath',
    }

    let modalW = () => {
        let contenido = () => (
            <embed
                type = "application/pdf"
                src = {src}
                id = "pdfDocument"
                width = "100%"
                height = "70%"
            />
        )

        return (
            <CustomModal
                boton1 = {<React.Fragment>Cerrar</React.Fragment>}
                boton2 = ""
                large = "large"
                isopen =  {modal}
                titulo = {props.titulo}
                contenido = {contenido()}      
                funcion1 = {() => {setModal(false)}}
            />
        )
    }

    let addBreak = (event) => {
        let cuenta = 0;
        let posicion = (event.editor.getData()).indexOf("page-break-after:always");

        while ( posicion != -1 ) {
            cuenta++;
            posicion = (event.editor.getData()).indexOf("page-break-after:always", posicion + 1);
        }

        let newPags = `Este documento consta de ${cuenta + 1}`
        let newData = (event.editor.getData()).replace(numPags, newPags)
        
        setNumPags(newPags)
        setDataHtml(newData)
    }

    return (
        <React.Fragment>
            {modalW()}
            <div className = "alert alert-pdf" style = {{marginBottom: 2}} align = "left">
                <Row>
                    <Col md = {6} style = {{marginTop: 8, paddingBottom: 6}}><i className = "fa fa-file"/> {props.titulo}</Col>
                    <Col md = {6} align = "right">
                        <div className = "btn-group">
                            <button className="btn btn-sm btn-default" onClick = {() => {props.cerrar()}} style = {{borderWidth: 0, color:"#66c168", fontSize: 16}} title = "Volver"><i className = "fa fa-arrow-circle-left" /></button>
                            <button className="btn btn-sm btn-default" onClick = {exportar} style = {{borderWidth: 0, color:"#c50000", fontSize: 16}} title = "Exportar como Pdf"><i className = {btnExport.icon} /></button>
                            <button className="btn btn-sm btn-default" onClick = {() => {descargar(`Notas_Cert-(${props.titulo})`)}} style = {{borderWidth: 0, color:"#495057", fontSize: 16}} title = "Descargar como Pdf"><i className = {btnDownload.icon} /></button>
                            <button className="btn btn-sm btn-default" onClick = {imprimir} style = {{borderWidth: 0, color:"#495057", fontSize: 16}} title = "Imprimir"><i className = {btnPrint.icon} /></button>
                        </div>
                    </Col>
                </Row>
            </div>
            <div id = "ck-document">
                <CKEditor
                    data = {dataHtml}
                    type = "document"
                    onChange = { ( event ) => {
                        setDataHtml(event.editor.getData()) 
                    }}
                    onSelectionChange = {(event) => {
                        addBreak(event)
                    }}
                    config = {configuraciones}
                    name = "Editor_1"
                />
            </div>
            <iframe id = "pdf-frame" style = {{display: "none"}}></iframe>
        </React.Fragment>
    )   
}

export default ReportEdit;



// WEBPACK FOOTER //
// ./src/components/Reportes/ReportEdit.jsx